import styled from "styled-components";
import { Box } from "@sproutsocial/seeds-react-box";

export const StyledMenuFooterBox = styled(Box)`
  padding: ${({ theme }) => theme.space[350]} ${({ theme }) => theme.space[400]};
  border-top: 1px solid ${(p) => p.theme.colors.container.border.base};
`;
